import React from "react";
import { Link } from "react-router-dom";

export default function TermsOfService() {
  return (
    <div style={{ maxWidth: 800, margin: "0 auto", padding: 24 }}>
      <Link to="/" style={backLinkStyle}>← Back to PDF ME</Link>

      <div style={cardStyle}>
        <h1 style={titleStyle}>📋 Terms of Service</h1>
        <p style={updatedStyle}>Last updated: February 17, 2026</p>

        <Section title="1. Acceptance of Terms">
          By accessing and using <strong>PDF ME</strong>, you agree to be bound by these Terms of Service.
          If you do not agree with any part of these terms, please do not use our application.
        </Section>

        <Section title="2. Description of Service">
          PDF ME is a free, browser-based PDF toolkit that allows you to:
          <ul style={listStyle}>
            <li>Create and edit PDF documents</li>
            <li>Convert PDFs to images, text, Word, Excel, and PowerPoint</li>
            <li>Merge and split PDF files</li>
            <li>Compress PDF files</li>
            <li>Create Word documents</li>
          </ul>
          All processing is done locally in your browser. No files are uploaded to any server.
        </Section>

        <Section title="3. User Responsibilities">
          You are responsible for:
          <ul style={listStyle}>
            <li>Ensuring you have the right to process the documents you upload.</li>
            <li>Complying with all applicable laws regarding the content of your documents.</li>
            <li>Maintaining the security of your own device and browser.</li>
          </ul>
        </Section>

        <Section title="4. Intellectual Property">
          The PDF ME application, including its design, code, and branding, is protected by
          intellectual property laws. You may not copy, modify, or distribute the application
          without permission.
        </Section>

        <Section title="5. Disclaimer of Warranties">
          PDF ME is provided <strong>"as is"</strong> without warranties of any kind, either express or implied.
          We do not guarantee that the service will be uninterrupted, error-free, or that the
          results will be accurate.
        </Section>

        <Section title="6. Limitation of Liability">
          In no event shall PDF ME or its creators be liable for any direct, indirect, incidental,
          special, or consequential damages arising from the use or inability to use our service.
        </Section>

        <Section title="7. File Processing">
          All file processing occurs locally on your device. We are not responsible for any data
          loss that may occur during processing. We recommend keeping backups of your original
          files before using any conversion or editing tools.
        </Section>

        <Section title="8. Modifications to Terms">
          We reserve the right to modify these terms at any time. Continued use of the application
          after changes constitutes acceptance of the new terms.
        </Section>

        <Section title="9. Governing Law">
          These terms shall be governed by and construed in accordance with applicable laws,
          without regard to conflict of law provisions.
        </Section>

        <Section title="10. Contact">
          If you have questions about these Terms of Service, please reach out through our
          application's support channels.
        </Section>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: 24 }}>
      <h2 style={sectionTitleStyle}>{title}</h2>
      <p style={textStyle}>{children}</p>
    </div>
  );
}

const backLinkStyle = {
  display: "inline-block",
  marginBottom: 20,
  color: "#FFD700",
  textDecoration: "none",
  fontWeight: 600,
  fontSize: 16,
};

const cardStyle = {
  background: "rgba(255,255,255,0.08)",
  backdropFilter: "blur(10px)",
  borderRadius: 16,
  padding: "36px 40px",
  border: "1px solid rgba(255,255,255,0.15)",
  color: "#fff",
};

const titleStyle = {
  fontSize: 36,
  fontWeight: 800,
  marginBottom: 4,
  background: "linear-gradient(45deg, #ff6b9d, #ffa500)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  backgroundClip: "text",
};

const updatedStyle = {
  fontSize: 14,
  color: "rgba(255,255,255,0.5)",
  marginBottom: 32,
};

const sectionTitleStyle = {
  fontSize: 20,
  fontWeight: 700,
  color: "#FFD700",
  marginBottom: 8,
};

const textStyle = {
  fontSize: 15,
  lineHeight: "1.7",
  color: "rgba(255,255,255,0.85)",
  margin: 0,
};

const listStyle = {
  marginTop: 10,
  paddingLeft: 20,
  lineHeight: "2",
};
